"use client";

import React from "react";

import Checkbox from "@/components/botanic/Checkbox";

type AgeGateRememberMeProps = {
  rememberUser: boolean;
  setRememberUser: (rememberUser: boolean) => void;
};

const AgeGateRememberMe: React.FC<AgeGateRememberMeProps> = ({
  rememberUser,
  setRememberUser,
}) => {
  return (
    <div className="mt-lg pb-lg">
      <Checkbox
        data-testid="age-gate-modal-checkbox"
        id="age-gate-remember"
        checked={rememberUser}
        className="[&>*]:leading-[1.5rem] [&>input]:mt-0.5"
        onChange={() => setRememberUser(!rememberUser)}
      >
        Remember me. <br />I confirm that this is not a shared device.
      </Checkbox>
    </div>
  );
};

export default AgeGateRememberMe;
